import React from 'react';
import { Grid } from '@material-ui/core';
import { sanlamIndigo } from 'Material-UI/colors';
import { IntlShape, injectIntl } from 'react-intl';
import {
  BodyContainer,
  AbsoluteGrid,
  StyledSmallSectionHeader,
} from 'containers/LegalNoticePage/styles';
import { MediumSectionHeader } from 'components/Typography';
import messages from 'containers/LegalNoticePage/messages';
import { translate } from 'helpers/intl';
import { get } from 'lodash';
import ScrollBack from 'components/ButtonBackToTop';

const CGU = [
  {
    title: 'first_title_CGU',
    description: 'first_description_CGU',
  },
  {
    title: 'second_title_cgu',
    description: 'second_description_cgu',
  },
  {
    title: 'third_title_cgu',
    description: 'third_description_cgu',
  },
  {
    title: 'forth_title_cgu',
    description: 'forth_description_cgu',
  },
  {
    title: 'five_title_cgu',
    description: 'five_description_cgu',
  },
  {
    title: 'six_title_cgu',
    description: 'six_description_cgu',
  },
  {
    title: 'seven_title_cgu',
    description: 'seven_description_cgu',
  },
  {
    title: 'eight_title_cgu',
    description: 'eight_description_cgu',
  },
  {
    title: 'nine_title_cgu',
    description: 'nine_description_cgu',
  },
  {
    title: 'ten_title_cgu',
    description: 'ten_description_cgu',
  },
  {
    title: 'eleven_title_cgu',
    description: 'eleven_description_cgu',
  },
  {
    title: 'twelve_title_cgu',
    description: 'twelve_description_cgu',
  },
  {
    title: 'tweenty_title_cgu',
    description: 'tweenty_description_cgu',
  },
];
const URL_REGEX = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]+\.[^\s]{2,}|www\.[a-zA-Z0-9]+\.[^\s]{2,})/gi;

const Body = (props: { intl: IntlShape }) => {
  const renderText = (txt: string) =>
    txt.split(' ').map((part, index) =>
      URL_REGEX.test(part) ? (
        <a key={index} href={'https://' + part}>
          {part}{' '}
        </a>
      ) : (
        part + ' '
      ),
    );

  return (
    <Grid container alignItems="center" justify="center">
      <BodyContainer>
        <AbsoluteGrid>
          <ScrollBack showBelow={1200} />
          <Grid container alignItems="center" justify="center">
            <Grid item xs>
              {CGU.map((item: { title: string; description: string }) => (
                <React.Fragment key={item.title}>
                  <MediumSectionHeader weight="500">
                    {translate(get(messages, item.title), props)}
                  </MediumSectionHeader>
                  <StyledSmallSectionHeader color={sanlamIndigo} weight="100">
                    {renderText(
                      translate(get(messages, item.description), props),
                    )}
                  </StyledSmallSectionHeader>
                </React.Fragment>
              ))}
            </Grid>
          </Grid>
        </AbsoluteGrid>
      </BodyContainer>
    </Grid>
  );
};
export default injectIntl(Body);
